import { createStore, applyMiddleware, compose } from "redux"
import rootReducer from "../reducers/RootReducer"
import loggerMiddleware from "../middleware/logger"
import monitorReducerEnhancer from "../enhancers/monitorReducer"
import { persistStore, persistReducer } from "redux-persist"
import storage from "redux-persist/lib/storage"
import autoMergeLevel2 from "redux-persist/lib/stateReconciler/autoMergeLevel2"

export default function configureStore(preloadedState) {
  const persistConfig = {
    key: "root",
    storage: storage,
    stateReconciler: autoMergeLevel2
  }
  const middlewares = [loggerMiddleware]
  const middlewareEnhancer = applyMiddleware(...middlewares)

  const enhancers = [middlewareEnhancer, monitorReducerEnhancer]
  const composedEnhancers = compose(...enhancers)
  const avmPersistReducer = persistReducer(persistConfig, rootReducer)
  const store = createStore(
    avmPersistReducer,
    preloadedState,
    composedEnhancers
  )
  const persistor = persistStore(store)

  return { store, persistor }
}
